import React, { useState } from 'react';
import { useDrop, useDrag } from 'react-dnd';

const Card = ({ data = {}, disabled }) => {
  const { name = '', data1 = null } = data;
  const [isOver, setIsOver] = useState(false);
  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'knight',
    canDrag: () => !disabled,
    item: { id: name },
    collect: monitor => ({ isDragging: !!monitor.isDragging() }),
  }));
  return (
    <div
      ref={drag}
      style={{
        padding: 4,
        border: (isOver || isDragging) ? '1px solid black' : '1px solid transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: 8,
        cursor: disabled ? 'default' : 'pointer',
      }}
      onMouseOver={() => setIsOver(true)}
      onMouseOut={() => setIsOver(false)}
    >
      <div>{name}</div>
      <div>{`持股比例 : ${data1} %`}</div>
    </div>
  );
};

const CardContain = ({ data = {}, returnError = () => {}, handleDrag = () => {}, onClick = () => {}, disabled }) => {
  const { name = '' } = data;

  const [{ isOver, isError }, drop] = useDrop(() => ({
    accept: 'knight',
    canDrop: () => !disabled,
    drop: item => { if (!returnError({ name, item: item.id }) && name !== item.id) handleDrag({ name, item: item.id }); },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
      isError: !!monitor.isOver() && returnError({ name, item: monitor.getItem().id }),
    }),
  }));
  return (
    <div
      ref={drop}
      style={{ marginLeft: 8, marginRight: 8, backgroundColor: isError ? 'red' : isOver ? 'gray' : 'transparent', borderRadius: 8 }}
      onClick={() => disabled ? {} : onClick(data) }
    >
      <Card data={data} disabled={disabled} />
    </div>
  );
};

const App = ({ ary = [], Item = null, returnError, handleDrag, onClick, disabled }) => (
  <div style={{ display: 'flex', flexDirection: 'column-reverse' }}>
    {/* {ary.length > 1 && <div style={{ height: 2, backgroundColor: 'gray', marginLeft: 16, marginRight: 16 }} />} */}
    <div style={{ display: 'flex' }}>
      {ary.map((o, i) => {
        const isFirst = i === 0;
        const isEnd = i === ary.length - 1;
        return (
          <div key={o.name} style={{ display: 'flex', flexDirection: 'column-reverse', alignItems: 'center', position: 'relative' }}>
            <div style={{ height: 2, backgroundColor: 'black', bottom: 0, right: isEnd ? '50%' : 0, left: isFirst ? '50%' : 0, position: 'absolute' }} />
            {(!isFirst) && (!isEnd) && <div style={{ height: 2, backgroundColor: 'gray', bottom: 0, right: '50%', left: 0 }} />}
            <div style={{ width: 2, height: 10, backgroundColor: 'black' }} />
            <CardContain data={o} {...{ returnError, handleDrag, onClick, disabled }} />
            {o.ary.length > 0 && <div style={{ width: 2, height: 10, backgroundColor: 'black' }} />}
            {o.ary.length > 0 && <Item {...{ Item, returnError, handleDrag, onClick, disabled }} ary={o.ary} />}
          </div>
        );
      })}
    </div>
  </div>
);

export default App;
